// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__15y_t","additionalInfo":"AgreementModal_additionalInfo__3Ptny"};